export const initialState = {
  loading: true,
  featureFlag: null,
};
